import { HStack, Box, useToast } from '@chakra-ui/react';

interface MatchActionsProps {
  match: any;
  submittedFaceUrl: string | null;
  API_URL: string;
}

export const MatchActions = ({ match, submittedFaceUrl, API_URL }: MatchActionsProps) => {
  const toast = useToast();

  const handleConfirmMatch = async () => {
    try {
      const response = await fetch(`${API_URL}/api/confirm-match`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          submitted_face: submittedFaceUrl || "unknown",
          match_data: match
        }),
        credentials: 'include',
      });

      if (!response.ok) {
        console.error('Failed to confirm match:', await response.text());
        throw new Error('Failed to confirm match');
      }

      toast({
        title: 'Match Confirmed',
        description: 'Thank you for helping improve our system.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error confirming match:', error);
      toast({
        title: 'Error',
        description: 'Failed to confirm match. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleRejectMatch = async () => {
    try {
      const response = await fetch(`${API_URL}/api/admin/reject-match`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          submitted_face: submittedFaceUrl || "unknown",
          match_data: match,
          reason: "different_person" // Default reason
        }),
        credentials: 'include',
      });

      if (!response.ok) {
        console.error('Failed to reject match:', await response.text());
        throw new Error('Failed to reject match');
      }

      toast({
        title: 'Match Rejected',
        description: 'Thank you for helping improve our system.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error rejecting match:', error);
      toast({
        title: 'Error',
        description: 'Failed to reject match. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <HStack spacing={2}>
      <Box 
        as="button"
        fontSize="sm" 
        color="white" 
        cursor="pointer" 
        onClick={handleConfirmMatch}
        p={1.5}
        borderRadius="md"
        bg="green.700"
        _hover={{ 
          bg: "green.600",
        }}
        transition="all 0.2s ease-in-out"
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={1}
        flex="1"
        whiteSpace="nowrap"
        h="32px"
      >
        Confirm Match
        <span>✓</span>
      </Box>

      <Box 
        as="button"
        fontSize="sm" 
        color="white" 
        cursor="pointer" 
        onClick={handleRejectMatch}
        p={1.5}
        borderRadius="md"
        bg="red.700"
        _hover={{ 
          bg: "red.600",
        }}
        transition="all 0.2s ease-in-out"
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={1}
        flex="1"
        whiteSpace="nowrap"
        h="32px"
      >
        Not a Match
        <span>✕</span>
      </Box>
    </HStack>
  );
}; 